
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 2.144C0 1.336.67.684 1.5.684S3 1.336 3 2.144c0 .808-.67 1.46-1.5 1.46S0 2.953 0 2.145zm0 5.843c0-.808.67-1.46 1.5-1.46S3 7.178 3 7.986c0 .808-.67 1.46-1.5 1.46S0 8.795 0 7.987zm1.5 4.381c-.83 0-1.5.662-1.5 1.46 0 .8.68 1.462 1.5 1.462S3 14.627 3 13.829c0-.799-.67-1.46-1.5-1.46zm16 2.435h-12c-.55 0-1-.439-1-.974 0-.536.45-.974 1-.974h12c.55 0 1 .438 1 .974 0 .535-.45.974-1 .974zM5.5 8.96h12c.55 0 1-.439 1-.974 0-.536-.45-.974-1-.974h-12c-.55 0-1 .438-1 .974 0 .535.45.974 1 .974zm0-5.843c-.55 0-1-.438-1-.973 0-.536.45-.974 1-.974h12c.55 0 1 .438 1 .974 0 .535-.45.973-1 .973h-12z","fill":"currentColor"}})])
          )
        }
      }
    